import React from 'react';
import { Skeleton } from '@vibe/core';

// Skeleton placeholder matching the Integrations page layout: recipe cards
// on top, active automations list below.
const IntegrationSkeleton = ({ recipes = 3, integrations = 2 }) => {
  return (
    <div aria-label="Loading automations">
      {/* Recipe cards */}
      <div className="integration-recipes">
        {[...Array(recipes)].map((_, index) => (
          <div key={`recipe-skeleton-${index}`} className="recipe-card" style={{ pointerEvents: 'none' }}>
            <Skeleton width="60px" height="60px" borderRadius="14px" />
            <div style={{ marginTop: 20, marginBottom: 8 }}>
              <Skeleton width="55%" height="20px" />
            </div>
            <div style={{ marginBottom: 8 }}>
              <Skeleton width="90%" height="13px" />
            </div>
            <div style={{ marginBottom: 24 }}>
              <Skeleton width="70%" height="13px" />
            </div>
            <Skeleton width="100%" height="42px" borderRadius="10px" />
          </div>
        ))}
      </div>

      {/* Active automations section */}
      <div style={{ marginTop: 48 }}>
        <Skeleton width="210px" height="24px" />
        <div style={{ marginTop: 10, marginBottom: 24 }}>
          <Skeleton width="290px" height="13px" />
        </div>
        <div className="active-integrations-list">
          {[...Array(integrations)].map((_, index) => (
            <div key={`integration-skeleton-${index}`} className="active-integration-item" style={{ pointerEvents: 'none' }}>
              <div className="integration-info">
                <Skeleton width="48px" height="48px" borderRadius="12px" />
                <div className="integration-details">
                  <Skeleton width="180px" height="17px" />
                  <div style={{ marginTop: 8, marginBottom: 10 }}>
                    <Skeleton width="320px" height="12px" />
                  </div>
                  <div className="integration-meta">
                    <Skeleton width="88px" height="24px" borderRadius="999px" />
                    <Skeleton width="120px" height="24px" borderRadius="999px" />
                  </div>
                </div>
              </div>
              <div className="integration-actions" style={{ alignItems: 'center' }}>
                <Skeleton width="36px" height="20px" borderRadius="10px" />
                <Skeleton width="64px" height="33px" borderRadius="8px" />
                <Skeleton width="64px" height="33px" borderRadius="8px" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IntegrationSkeleton;
